import React, { createContext, useContext, useState, useCallback } from 'react';
import axios from 'config/axios';
import PreviewModal from 'components/LearningContent/PreviewModal';

const LessonPreviewContext = createContext(null);

export function useLessonPreview() {
    const ctx = useContext(LessonPreviewContext);
    if (!ctx) {
        return {
            openLessonPreview: () => {},
            closeLessonPreview: () => {},
        };
    }
    return ctx;
}

export function LessonPreviewProvider({ children }) {
    const [lessonToPreview, setLessonToPreview] = useState(null);

    const openLessonPreview = useCallback((lessonId) => {
        if (!lessonId) return;
        axios
            .get(`/api/v4/lessons/${lessonId}`)
            .then((res) => setLessonToPreview(res?.data ?? res))
            .catch((err) => {
                console.error('Lesson preview failed:', err);
            });
    }, []);

    const closeLessonPreview = useCallback(() => {
        setLessonToPreview(null);
    }, []);

    const value = {
        lessonToPreview,
        openLessonPreview,
        closeLessonPreview,
    };

    return (
        <LessonPreviewContext.Provider value={value}>
            {children}
            <PreviewModal
                lessonToPreview={lessonToPreview}
                togglePreviewLessonModal={closeLessonPreview}
            />
        </LessonPreviewContext.Provider>
    );
}
